// src/App.jsx

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import DownloaderPage from './pages/DownloaderPage/DownloaderPage';
import LiveTvPage from './pages/LivePage/LivePage';
import HomePage from './pages/HomePage/HomePage';
import AboutPage from './pages/AboutPage/AboutPage';
import FaqPage from "./pages/FaqPage/FaqPage";
import SoftwarePage from "./pages/SoftwarePage/SoftwarePage";
import FrequenciesPage from "./pages/FrequenciesPage/FrequenciesPage";
import { ThemeProvider } from './context/ThemeContext';
import './styles/global.css';
import AdminPage from './pages/AdminPage/AdminPage';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/live" element={<LiveTvPage />} />
            <Route path="/downloader" element={<DownloaderPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/software" element={<SoftwarePage />} /> 
            <Route path="/frequencies" element={<FrequenciesPage />} />
            <Route path="/admin" element={<AdminPage />} />

          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
